<template lang="">
    <div ref="container">
        <div class="banner-wrap">
            <div class="banner">
                <div class="swipe-wrap">
                    <van-swipe :autoplay="3000" indicator-color="white" width="100%" ref="banner">
                        <van-swipe-item v-for="(banner, b) in banners" :key="b">
                            <van-image
                                width="100%"
                                height="100%"
                                fit="cover"
                                :src="banner.url"
                                :alt="banner.name"
                            />
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
        </div>
        <div class="lists">
            <router-link
                :to="'/venue/detail/' + item.id"
                class="item"
                v-for="(item, i) in lists"
                :key="i"
            >
                <div class="image">
                    <van-image :src="item.thumb" fit="cover" />
                </div>
                <div class="name">{{ item.name }}</div>
                <div class="desc">
                    {{ item.address }}
                </div>
            </router-link>
        </div>
        <div class="empty-wrap">
            <van-loading v-if="!loaded">
                加载中...
            </van-loading>
            <van-empty
                description="暂无任何场馆"
                :image="require('@images/nodata.png')"
                v-if="lists.length === 0"
            />
        </div>
    </div>
</template>
<script>
import { getVenueData } from '@api/public';
import { getVenueList } from '@api/venue';
export default {
    name: 'Venue',
    data() {
        return {
            banners: [],
            lists: [],
            active: 0,
            where: {
                page: 1,
                limit: 12
            },
            loaded: false,
            loading: false
        };
    },
    created() {
        this.getVenueParams();
    },
    watch: {
        $route(n) {
            if (n.name === 'Classroom') {
                this.getVenueParams();
                if (this.cates.length > 0) {
                    this.$set(this, 'cid', this.cates[this.active].id);
                    this.where.page = 1;
                    this.loaded = false;
                    this.loading = false;
                    this.$set(this, 'lists', []);
                    this.getLists();
                }
            }
        }
    },
    mounted() {
        this.getLists();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.getLists();
        });
    },
    methods: {
        getVenueParams() {
            let that = this;
            getVenueData().then(res => {
                that.$set(that, 'banners', res.data.banners);
            });
        },
        getLists() {
            let that = this;
            if (this.loaded == true || this.loading == true) return;
            this.loading = true;
            getVenueList(this.where, this.cid).then(res => {
                that.loading = false;
                that.lists.push.apply(that.lists, res.data);
                that.loaded = res.data.length < that.where.limit; //判断所有数据是否加载完成；
                that.where.page = that.where.page + 1;
            });
        }
    }
};
</script>
